export type CheckStatus = 'checking' | 'ok' | 'error' | 'unknown';

export interface InterviewStartCheckParams {
  isSessionPrepared: boolean;
  aiError: string;
  cameraCheckStatus: CheckStatus;
  micCheckStatus: CheckStatus;
}

export interface InterviewStartCheckResult {
  canStart: boolean;
  isChecking: boolean;
  blockers: string[];
}

/**
 * 面接開始ボタンの有効/無効を決定するロジック。
 *
 * - canStart: true のときだけボタンを押せる
 * - isChecking: いずれかがまだ確認中（スピナー表示用）
 * - blockers: 問題がある項目名のリスト（エラーメッセージ表示用）
 *
 * unknown は「許可ダイアログ未表示」を意味し、開始時に許可を求めるため通過扱い。
 * error は「明示的に拒否済み」のため通過不可。
 */
export function checkInterviewStartConditions(
  params: InterviewStartCheckParams
): InterviewStartCheckResult {
  const { isSessionPrepared, aiError, cameraCheckStatus, micCheckStatus } = params;

  const aiOk = isSessionPrepared && !aiError;
  const cameraOk = cameraCheckStatus === 'ok' || cameraCheckStatus === 'unknown';
  const micOk = micCheckStatus === 'ok' || micCheckStatus === 'unknown';

  const isChecking =
    cameraCheckStatus === 'checking' ||
    micCheckStatus === 'checking' ||
    (!isSessionPrepared && !aiError);

  const blockers: string[] = [];
  if (!aiOk) blockers.push('AI接続');
  if (cameraCheckStatus === 'error') blockers.push('カメラ');
  if (micCheckStatus === 'error') blockers.push('マイク');

  const canStart = aiOk && cameraOk && micOk && !isChecking;

  return { canStart, isChecking, blockers };
}
